// Mapa del ERP: la matriz de TODAS las pantallas (ruta, estado del backend, API, acciones). Sale del
// mismo archivo que arma el menú, así que nunca se desfasa. Solo en VALIDACIÓN/DEV.
import { useMemo, useState } from 'react';
import { InsigniaBackend } from '../comun/ui';
import { useSesion } from '../sesion/SesionContexto';
import { NOMBRE_ESTADO, PANTALLAS, type EstadoBackend } from './navegacion';
import { useModoRevision } from './salud';

export function MapaErp({ alAbrir }: { alAbrir: (ruta: string) => void }) {
  const revision = useModoRevision();
  const { puede } = useSesion();
  const [filtro, setFiltro] = useState<EstadoBackend | ''>('');
  const [texto, setTexto] = useState('');
  const filas = useMemo(
    () =>
      PANTALLAS.filter(
        (p) =>
          (!filtro || p.backend === filtro) &&
          (!texto ||
            `${p.modulo.nombre} ${p.nombre} ${p.ruta}`.toLowerCase().includes(texto.toLowerCase())),
      ),
    [filtro, texto],
  );
  const cuenta = (e: EstadoBackend) => PANTALLAS.filter((p) => p.backend === e).length;
  if (!revision)
    return <p className="apagado">El mapa del ERP solo se ve en VALIDACIÓN o en desarrollo.</p>;
  return (
    <div className="pantalla mapa-erp" data-pantalla="mapa">
      <div className="barra-filtros">
        <h2>Mapa del ERP</h2>
        <span className="apagado">
          {PANTALLAS.length} pantallas · A {cuenta('A')} · B {cuenta('B')} · C {cuenta('C')}
        </span>
        <input
          aria-label="Filtrar pantallas"
          placeholder="Filtrar por módulo, pantalla o ruta…"
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
        />
        <select
          aria-label="Estado del backend"
          value={filtro}
          onChange={(e) => setFiltro(e.target.value as EstadoBackend | '')}
        >
          <option value="">Todos los estados</option>
          {(['A', 'B', 'C'] as const).map((e) => (
            <option key={e} value={e}>
              {e} · {NOMBRE_ESTADO[e]}
            </option>
          ))}
        </select>
      </div>
      <div className="grilla-contenedor">
        <table className="grilla compacta" aria-label="Matriz de pantallas">
          <thead>
            <tr>
              <th>Módulo</th>
              <th>Pantalla</th>
              <th>Ruta</th>
              <th>Estado</th>
              <th>Front</th>
              <th>API</th>
              <th>Habilitadas</th>
              <th>Pendientes</th>
              <th>Permiso</th>
            </tr>
          </thead>
          <tbody>
            {filas.map((p) => {
              const permitido = !p.permiso || puede(p.permiso);
              return (
                <tr key={p.ruta} data-ruta={p.ruta} className={permitido ? '' : 'apagado'}>
                  <td>
                    {p.modulo.nombre}
                    {p.seccion ? <span className="apagado"> › {p.seccion}</span> : null}
                  </td>
                  <td>
                    <button
                      type="button"
                      className="enlace"
                      disabled={!permitido}
                      onClick={() => alAbrir(p.ruta)}
                    >
                      {p.nombre}
                    </button>
                  </td>
                  <td className="mono">#/{p.ruta}</td>
                  <td>
                    <InsigniaBackend estado={p.backend} />
                  </td>
                  <td>{p.abre ? 'construida' : (p.checkpoint ?? 'preparada')}</td>
                  <td className="mono chico">{p.api?.join(' · ') ?? '—'}</td>
                  <td className="chico">{p.habilitadas?.join(' · ') ?? '—'}</td>
                  <td className="chico">{p.pendientes?.join(' · ') ?? '—'}</td>
                  <td className="mono chico">{p.permiso ?? '—'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
